import { logError } from 'lib/observability';

import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';
import { getHasHdWords } from './getHasHdWords';
import { getIsPremium } from './getIsPremium';

export const getHasAccessToPremiumVoice = (state?: SubscriptionStoreState): boolean => {
  const latestState = state ?? useSubscriptionStore.getState();
  const isPremium = getIsPremium(latestState);
  const hasHdWords = getHasHdWords(latestState);

  // I want to err on the side of caution and return true if we are not sure whether the user is premium
  // But ideally this should not happen because it's kind of a weird state, we should wait will all premium/free conditions until the subscriptionStore is loaded
  if (latestState.isLoading) {
    logError(new Error('getHasAccessToPremiumVoice called while subscriptionStore is loading'));
    return true;
  }

  return isPremium && hasHdWords;
};
